import { Route, Routes } from 'react-router-dom'
import PageHeader from 'components/AppBar/PageHeader'
import { BasePathProvider, useSession } from 'components/Providers'
import { Box, Paper } from '@mui/material'
import AdmissionsTabs, { tabConfig } from './Tabs'
import RedirectToFirstPermitted from 'components/RedirectToPermittedTab'
import NotFound from 'components/NotFound'
import Protected from 'components/Protected'
import ApplicationsDashboard from './AdmissionsDashboard'
import LotteryFiles from './LotteryFiles'
import AdmissionsIndex from './AdmissionRecords'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo } from 'react'
import dayjs from 'dayjs'
import { getTypes, getGradeLevels, getClients, getAcademicYearProviders } from 'store/lookup';
import EnrollmentSummary from './EnrollmentSummary'

const MIN_ACADEMIC_YEAR_START = '2026-06-30';
const MAX_ACADEMIC_YEAR = '2028-07-01';

export default function StudentAdmissions() {
    const basePath = '/admission'
    const { district } = useSession()
    const dispatch = useDispatch()
    const { clients: clientList } = useSelector(state => state.lookup)
    const clientSchools = clientList?.map(item => item.client?.schools?.map(school => ({ ...school, type: item.client?.type }))).flat() || []
    const gradeLevel = useSelector(state => state.lookup.gradeLevel)
    const types = useSelector(state => state.lookup.types)?.filter(item => item.category === 'applicationStatus')
    const filteredClients = clientSchools?.filter(client => client?.type === 'school')
    const academicYearProviders = useSelector(state => state.lookup.academicYearProviders);


    const academicYears = useMemo(
        () => (academicYearProviders ?? [])
            .filter(a => dayjs(a.startDate).isAfter(MIN_ACADEMIC_YEAR_START))
            .filter(a => dayjs(a.endDate).isBefore(MAX_ACADEMIC_YEAR))
            .map(a => ({ id: a.id, label: a.name, startDate: a.startDate, yearApp: dayjs(a.startDate).year() % 100 })),
        [academicYearProviders],
    );

    useEffect(() => {
        if (!academicYearProviders) dispatch(getAcademicYearProviders());
    }, [academicYearProviders, dispatch]);

    useEffect(() => {
        if (!clientList?.length && district?.isServiceProvider) {
            dispatch(getClients())
        }
    }, [clientList, dispatch, district])

    useEffect(() => {
        dispatch(getGradeLevels())
    }, [dispatch, district])

    useEffect(() => {
        if (!types) {
            dispatch(getTypes());
        }
    }, [types, dispatch]);

    return (
        <BasePathProvider value={`${basePath}/`}>
            <Box sx={{ mb: 1 }}>
                <PageHeader title={'Admissions'} />
            </Box>
            <Paper sx={{ width: '100%', p: 2, }}>
                <AdmissionsTabs />
            </Paper>
            <Box>
                <Routes>
                    <Route path="/">
                        <Route index element={<RedirectToFirstPermitted basePath={basePath} items={tabConfig} />} />
                        <Route path={"application-list/*"} element={<Protected permission="application.application"><AdmissionsIndex clientSchools={filteredClients} gradeLevel={gradeLevel} types={types} academicYears={academicYears} /></Protected>} />
                        <Route path={"dashboard/*"} element={<Protected permission="application.application"><ApplicationsDashboard academicYears={academicYears} /></Protected>} />
                        {district?.isServiceProvider && (
                            <Route path={"lottery-files/*"} element={<Protected permission="application.lottery"><LotteryFiles clientSchools={filteredClients} /></Protected>} />
                        )}
                        <Route path={"enrollment-summary/*"} element={<Protected permission="application.application"><EnrollmentSummary clientSchools={filteredClients} academicYears={academicYears} /></Protected>} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </Box>
        </BasePathProvider>
    )
}
